import { render } from "./ServiceInfoView.vue?vue&type=template&id=1640062f&scoped=true"
import script from "./ServiceInfoView.vue?vue&type=script&lang=js"
export * from "./ServiceInfoView.vue?vue&type=script&lang=js"

import "./ServiceInfoView.vue?vue&type=style&index=0&id=1640062f&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1640062f"]])

export default __exports__